const liveIvr = {
  'Live checks are stored privately without a demo clinic assignment.':
    'Las verificaciones en vivo se guardan de forma privada sin asignarse a una cl\u00ednica de demostraci\u00f3n.',
  'Live insurance verification': 'Verificaci\u00f3n de seguro en vivo',
  'Live insurance verification is unavailable. Close this form and try again.':
    'La verificaci\u00f3n de seguro en vivo no est\u00e1 disponible. Cierre este formulario e intente de nuevo.',
  'Checking private live IVR access...': 'Comprobando el acceso privado a IVR en vivo...',
  'Only an administrator can submit live insurance verification.':
    'Solo un administrador puede enviar una verificaci\u00f3n de seguro en vivo.',
  'I confirm this submission uses real patient information and will send an insurance verification request to pVerify. I am authorized to submit it.':
    'Confirmo que este env\u00edo utiliza informaci\u00f3n real del paciente y enviar\u00e1 una solicitud de verificaci\u00f3n de seguro a pVerify. Tengo autorizaci\u00f3n para enviarla.',
};
export default liveIvr;
